import script from "./Motolino-Invite.vue?vue&type=script&setup=true&lang=js"
export * from "./Motolino-Invite.vue?vue&type=script&setup=true&lang=js"

import "./Motolino-Invite.vue?vue&type=style&index=0&id=bb397f46&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb397f46"]])

export default __exports__